import { Link } from "react-router-dom";
import StarIconPoints from "../Svgs/StarIconPoints";

const PointsToVoucherCard = ({ pointingWallet }) => {
  return (
    <div className="tw-relative tw-flex tw-flex-col tw-mt-6 tw-text-gray-700 tw-bg-white tw-shadow-md tw-bg-clip-border tw-rounded-xl tw-w-96">
      <div className="tw-p-4">
        <h5 className="tw-block tw-mb-2 tw-font-sans tw-text-xl tw-antialiased tw-font-semibold tw-leading-snug tw-tracking-normal tw-text-blue-gray-900">
          Pointing Wallet
        </h5>
        <h5 className="tw-flex tw-items-center tw-gap-2 tw-mb-2 tw-font-sans tw-text-lg tw-antialiased tw-font-semibold tw-leading-snug tw-tracking-normal tw-text-blue-gray-900">
          You Have{" "}
          <span className="tw-text-xl tw-font-bold tw-text-primary">
            {pointingWallet ?? 0}
          </span>
          <StarIconPoints />
        </h5>
        <p className="tw-block tw-font-sans tw-text-base tw-antialiased tw-leading-relaxed tw-text-inherit">
          Convert your points into a vouchers
        </p>
      </div>
      <div className="tw-p-4 tw-pt-0">
        <Link
          to={"/vouchers-list"}
          className="tw-align-middle tw-select-none tw-font-sans tw-font-bold tw-text-center tw-uppercase tw-transition-all tw-disabled:opacity-50 !tw-no-underline tw-disabled:shadow-none tw-disabled:pointer-events-none tw-text-xs tw-py-2 tw-px-4 !tw-rounded-lg !tw-bg-primary tw-text-white tw-shadow-md tw-shadow-gray-900/10 hover:tw-shadow-lg hover:tw-shadow-gray-900/20 focus:tw-opacity-[0.85] focus:tw-shadow-none active:tw-opacity-[0.85] active:tw-shadow-none"
          type="button"
        >
          Convert To Voucher
        </Link>
      </div>
    </div>
  );
};

export default PointsToVoucherCard;
